class LiveSearch extends HTMLElement {
  static observedAttributes = ["q"];

  constructor() {
    super();

    this.currentQueryId = 0;
  }

  connectedCallback() {}

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "q") {
      this._fetchQuery(newValue);
    }
  }

  _fetchQuery(q) {
    if (q.trim() === "") {
      this.results.innerHTML = "";
      this.defaultContent.style.display = null;
      return;
    }

    var requestResponse;

    this.currentQueryId++;
    const queryId = this.currentQueryId;
    fetch(
      `${this.url}?q=${q}&resources[type]=product,collection,page,query&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,body&section_id=predictive-search`,
    )
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        if (queryId !== this.currentQueryId) return;

        const resultsSection = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search");

        const ariaLiveContent =
          resultsSection.querySelector("[data-aria-live]")?.dataset.ariaLive ||
          "";

        this.defaultContent.style.display = "none";
        this.results.innerHTML = resultsSection.innerHTML;

        this.dispatchEvent(
          new CustomEvent("live-search:updated", {
            bubbles: true,
            detail: { ariaLiveContent },
          }),
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }

  get url() {
    return this.getAttribute("url");
  }

  get results() {
    return this.querySelector("[data-results]");
  }

  get defaultContent() {
    return this.querySelector("[data-default-content]");
  }
}

if (!customElements.get("live-search")) {
  customElements.define("live-search", LiveSearch);
}
